/**
 * The soundtrack, by J-Bot. Files live in public/music; titles are the track names. Each track is cued when its
 * chapter begins, and the list loops in this order otherwise.
 */
export interface Track { file: string; title: string; artist: string; /** the chapter that cues it, if any */ chapter?: string; }

const ARTIST = 'J-Bot';
const track = (name: string, chapter?: string): Track => ({ file: encodeURI(`/music/${name}.mp3`), title: name, artist: ARTIST, chapter });

export const TRACKS: Track[] = [
  track('Challenger Deep', 'deeper'),
  track('The Halo', 'wider'),
  track('Lonely Orbit', 'time'),
  track('Staura Maxx', 'light'),
  track('Singularity', 'pit')
];

export const CREDIT = 'Copyright 2026, J-Bot & The Bot Boyz';
